import { useEffect, useState } from "react";
import { Grid } from '@mui/material';
import { useNavigate } from "react-router-dom";
import CustomTable from "../../components/common/CustomTable/CustomTable";
import { ModalConfirm } from "../../components/common/ModalConfirm/ModalConfirm";
import { SpecificSubcategoryModal } from "./components/SpecificSubcategoryModal";
import { useSpecificSubcategoryStore } from "../../hooks/useSpecificSubcategoryStore";

const columns = [
    { type: 'options', field: 'options', label: 'Acciones', align:'center' },
    { type: 'text', field: 'name', label: 'Nombre', align:'center' },
    { type: 'text', field: 'description', label: 'Descripcion', align:'center' },
    { type: 'detail', field: 'detail', label: 'Detalle', align:'center' },
];

export const SpecificSubcategoryView = () => {

    const navigate = useNavigate();
    // const { search } = useSelector(selectHeaderState);

    const { setActionSpecificSubcategory, getSpecificsubcategories, getSpecificsubcategoriesByCompany, deleteSpecificsubcategory } = useSpecificSubcategoryStore();

    const [loading, setLoading] = useState(false);
    const [subcategories, setSubcategories] = useState<any>([]);
    const [rowSelected, setRowSelected] = useState<any>('');
    const [showModal, setShowModal] = useState<boolean>(false);
    const [showModalConfirm, setShowModalConfirm] = useState<boolean>(false);
    const [searchTimeout, setSearchTimeout] = useState<any>(null);

    useEffect(() => {
        getSpecificsubcategoriesByCompanyApi()
    },[])

    const getSpecificsubcategoriesByCompanyApi = async(search='') => {
        try {
            setLoading(true);
            const response = await getSpecificsubcategoriesByCompany(search);
            if(!response){
                setSubcategories([]);
                setLoading(false);
                return false;
            }else{
                setSubcategories(response || []);
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        }
    }

    const onAdd = () => {
        setActionSpecificSubcategory('add');
        setShowModal(true);
    }
    const onEdit = (rowSelected:any) => {
        setActionSpecificSubcategory('edit');
        setRowSelected(rowSelected);
        setShowModal(true);
    }
    const onDelete = (rowSelected:any) => {
        setActionSpecificSubcategory('delete');
        setRowSelected(rowSelected);
        setShowModalConfirm(true);
    }
    const onDetails = (rowSelected:any) => {
        setActionSpecificSubcategory('detail');
        setRowSelected(rowSelected);
        setShowModal(true);
    }

    const onDeleteConfirm = async() => {
        if (rowSelected) {
            setLoading(true);
            const response = await deleteSpecificsubcategory(rowSelected.id)
            if(response){
                getSpecificsubcategoriesByCompanyApi();
                setShowModalConfirm(false);
                setLoading(false);
                setRowSelected('');
            }else{
                setLoading(false);
                return false;
            }
        }
    }

    const onSearch = (term) => {
        clearTimeout(searchTimeout)
        setSearchTimeout(
            setTimeout(() => { getSpecificsubcategoriesByCompanyApi(term)}, 1000)
        )
    }

    const clearState = () => {
        setRowSelected('');
    }

    return (
        <>
            <Grid item xs={12}>
                <CustomTable 
                    title={'Lineas'}
                    columns={columns} 
                    loading={loading}
                    rows={subcategories || []}
                    onRowClick={() => {}}
                    hasOptions
                    onAddFn={onAdd}
                    onAddFnName={'Nueva linea'}
                    onDetails={onDetails}
                    onDelete={onDelete}
                    onEdit={onEdit}
                    onSearch={onSearch}
                    dense
                />
            </Grid>
            {
                showModal && (
                    <SpecificSubcategoryModal
                        open = {showModal}
                        closeModal = {() => {setShowModal(false)}}
                        subcategorySelected = {rowSelected}
                        listsubcategories = {getSpecificsubcategoriesByCompanyApi}
                        clearState = {clearState}
                    />
                )
            }
            {
                showModalConfirm && (
                    <ModalConfirm
                        open={showModalConfirm}
                        closeModal={()=>{ setShowModalConfirm(false); clearState()}}
                        onConfirm={onDeleteConfirm}
                        status={loading}
                    />
                )
            }
        </>
    )
}